import $ from 'jquery';

import 'slick-carousel';


let slider = {
    init() {

        this.slider();

        if($('div').hasClass('page-product')){
            slider.sliderProduct();
            slider.sliderRelatedProduct();
        }
        if($('body').hasClass('page-node-type-marque')){
            slider.sliderTimeline();
            slider.sliderTextImage();
            slider.sliderPartner();
        }
        if($('body').hasClass('page-node-type-landing')){
            slider.sliderRelatedProduct();
            slider.sliderTextImage();
            slider.sliderPanel();
        }
        if($('body').hasClass('page-node-type-homepage')){
            slider.sliderRelatedProduct();
        }
    },
    slider() {
        $('.slider').slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows : false,
            speed: 1000,
            infinite: true,
            centerMode: true,
            slidesToShow: 1,
            centerPadding: '350px',
            responsive: [
                {
                  breakpoint: 1279,
                  settings: {
                    centerPadding: '150px',
                  }
                },
                {
                  breakpoint: 1023,
                  settings: {
                    centerPadding: '100px',
                  }
                },
                {
                  breakpoint: 755,
                  settings: {
                    centerPadding: '50px',
                  }
                },
            ]
        })
    },
    sliderProduct(){
        $('.slider-product-detail').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav',
            responsive: [
                {
                  breakpoint: 755,
                  settings: {
                    dots: true,
                  }
                },
            ]
        });
        $('.slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.slider-product-detail',
            dots: false,
            arrows: false,
            //centerMode: true,
            focusOnSelect: true,
            vertical: true,
        });
    },
    sliderRelatedProduct(){
        $('.slider-related-product').slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows : false,
            speed: 1000,
            infinite: true,
            centerMode: true,
            slidesToShow: 4,
            centerPadding: '150px',
            draggable: true,
            swipeToSlide: true,
            responsive: [
            {
              breakpoint: 1279,
              settings: {
                slidesToShow: 4,
                centerPadding: '70px',
              }
            },
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 3,
                centerPadding: '70px',
              }
            },
            {
              breakpoint: 755,
              settings: {
                slidesToShow: 1,
                centerPadding: '70px',
              }
            },
          ]
        })
    },
    sliderTimeline(){
        $('.block-slider-timeline .timeline').slick({
            arrows : true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 1023,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 755,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                },
            ]
        })
    },
    sliderTextImage(){
        var slides = $('.block-slider-text-image .slide');
        $('.block-slider-text-image').slick({
            arrows : false,
            infinite: true,
            fade : true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1200,
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            slides.removeClass('slideIn slideNext start');
            slides.eq(currentSlide).addClass('slideIn');
            slides.eq(nextSlide).addClass('slideNext');
        });
    },
    sliderPartner(){
        $('.block-partner .slider-partner').slick({
            arrows : true,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerPadding: '100px',
            infinite: true,
            centerMode: true,
            responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 1023,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerPadding: '80px',
                  }
                },
                {
                  breakpoint: 755,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '30px',
                  }
                },
            ]
        })
    },
    sliderPanel(){
        $('.slider-panel .slide').each(function(){
            $('figure:nth-of-type(1)').addClass('current');

            $(this).prev().find('figure:nth-of-type(1)').clone().appendTo($(this).find('.flex-row')).addClass('prev').removeClass('current');

            $(this).next().find('figure:nth-of-type(1)').clone().appendTo($(this).find('.flex-row')).addClass('next').removeClass('current');


            if( $(this).is($(".slide:nth-of-type(1)")) ){
                $('.slider-panel .slide:nth-last-of-type(1)').find('figure:nth-of-type(1)').clone().appendTo($(this).find('.flex-row')).addClass('prev').removeClass('current');
            }

            if( $(this).is($(".slide:last")) ){
                $('.slider-panel .slide:nth-of-type(1)').find('figure:nth-of-type(1)').clone().appendTo($(this).find('.flex-row')).addClass('next').removeClass('current');
            }
        })

        var slides = $('.slider-panel .slide');
        $('.slider-panel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            fade: false,
            autoplaySpeed: 4000,
            speed: 0,
            cssEase: 'ease-in',
            nextArrow: $('.btn-next'),

        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            slides.removeClass('slideIn slideNext start');
            slides.eq(currentSlide).addClass('slideIn');
            slides.eq(nextSlide).addClass('slideNext');
        });
    }
}

export default slider;
